import type { Features } from "owa-graph-schema";
import { getUserFeatureAccessTable, type UserFeatureAccess } from "../database";
import { logGreyError } from "owa-analytics";
import { getCurrentTimestamp } from "../utils";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

/**
 * Upserts (inserts or updates) user feature access data into the IndexedDB cache.
 */
export const upsertUserFeatureAccessToCache = async (ownerId: string, networkFeatureAccess: (Features | null)[]): Promise<void> => {
    const cacheEntry: UserFeatureAccess = {
        ownerId,
        featureAccess: networkFeatureAccess,
        timestamp: getCurrentTimestamp(),
    };
    getUserFeatureAccessTable()
        .put(cacheEntry)
        .catch((error: any) => {
        logGreyError("PlacesAnalytics_UpsertUserFeatureAccessToCache_Error", getModuleContextMailboxInfo(), error);
    });
};
